import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import Loading from "../../components/Loading/Loading";

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './CompanyManagement.module.css';
import { useHistory } from "react-router-dom";
import GenericModal from "../../UI/GenericModal";
import { LegalEntityCompanyServicesApi } from "../../service";
import { isSuperuserValue } from "../../access/access";

const CompanyManagement = () => {
  const [companiesList, setCompaniesList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const history = useHistory();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    setIsLoading(true);
    let mounted = true;

    const legalEntityCompanyServicesApi = new LegalEntityCompanyServicesApi();
    legalEntityCompanyServicesApi.getLegalEntityCompanyMonitor( (error, data) => {
      if (mounted) {
        if (!error) {
          console.log("Companies list: ", data);
          setCompaniesList(data);
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }

      setIsLoading(false);
    });

    return () => {
      mounted = false;
    }
  }, []);

  const editCompanyHandler = (companyId) => {
    setIsLoading(true);
      history.push('/edit-company?companyId='+companyId);
  }

  const deleteCompanyHandler = (company) => {
    setIsLoading(true);
    const legalEntityCompanyServicesApi = new LegalEntityCompanyServicesApi();
    legalEntityCompanyServicesApi.deleteLegalEntityCompanyById(company.id, (error, data) => {
      if (!error) {
        modalDataHandler("", `The company "${company.name}" was deleted`, 'notification', () => window.location.reload())  
      } else {
        setError(() => {
          throw new Error ("");
          // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
        })
      }
    })
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  return <div className="pt-5 pb-2 d-flex justify-content-center align-items-center position-relative">
    <img
      src={nexiLogo}
      className={`${styles.logo}`}
      alt="nexi-group"
    />
    <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
    {!isLoading && <table className={`${styles.tableStyle}`}>
      <thead>
        <tr>
          <th className="px-2">Parent Company</th>
          <th className="px-2">Subsidiary</th>
          <th className="px-2">Company</th>
          <th className={`${styles.buttonsCol} px-1`}>
            <SubmitButton class={styles.newElementButton} click={() => history.push('/new-company')} align="center">New</SubmitButton>
          </th>
        </tr>
      </thead>
      <tbody>
        {companiesList.map( (el, index) => {
          const company = el.legalEntitySubsidiaries[0].legalEntityCompanies[0];
          return (
            <tr key={index}>
              <td className="p-3">{el.name}</td>
              <td className="p-3">{el.legalEntitySubsidiaries[0].name}</td>
              <td className="p-3">{company.name}</td>
              <td>
                <div className="d-flex">
                  <SubmitButton click={() => editCompanyHandler(company.id)}>Edit</SubmitButton>
                    <SubmitButton click={() => modalDataHandler(
                      "Delete Company",
                      `Delete Company "${company.name}"?`,
                      'confirmation',
                      () => deleteCompanyHandler(company) 
                    )}
                    disabled={!company.deletable}>Delete</SubmitButton>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>}
    {isLoading && <Loading />}
  </div>;
};

export default CompanyManagement;
